import SessionAccessStatusError from './SessionAccessStatusError';

export default SessionAccessStatusError;
